import React from 'react'
import deleteModalIcon from '../../../../assets/delete-modal-icon.svg'

function DeleteModal({ isOpen, onClose, onConfirm, returnItem }) {
  if (!isOpen) return null;

  const handleDelete = () => {
    if (onConfirm && returnItem) {
      onConfirm(returnItem);
    }
    onClose();
  };

  return (
    <div
      className="returns-delete-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="returns-delete-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="deleteRecordTitle"
      >
        <div className="modal-icon">
          <img src={deleteModalIcon} alt="Delete" />
        </div>
        <h3 className="modal-title" id="deleteRecordTitle">
          Delete Record
        </h3>
        <p className="modal-message">
          Are you sure you want to delete this record? This action cannot be undone.
        </p>
        <div className="modal-actions">
          <button
            type="button"
            className="modal-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="modal-delete-btn"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
